import { LegalDocument } from '@/components/LegalDocument'
import { TERMS_HTML } from '@/legal/terms.generated'
import { TERMS_VERSION } from '@parse/shared'

export function TermsPage() {
  return (
    <LegalDocument
      html={TERMS_HTML}
      title="Terms of Service"
      version={TERMS_VERSION}
      lastUpdated="July 1, 2026"
    />
  )
}
